// Sentry must be initialized before any other app code so all global error
// handlers (uncaught exceptions, unhandled rejections, network) are wrapped.
import "@/sentry";

import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // React 19 root error hooks → report to Sentry.
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── PWA — register the service worker for offline + installability ──
// Only in production builds; dev has hot reload noise from the SW cache.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => {
        // Don't break the app if SW registration fails — offline is a
        // progressive enhancement, not a hard requirement.
        console.warn('Service worker registration failed:', err);
      });
  });
}
